<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-clapperboard-play mr-3"></i>On-Demand Content</h3>
        <div class="mt-6 pb-6">
            <div class="columns is-gapless has-text-white" v-if="isPreRegistation">
                <div class="column is-narrow"></div>
                <div class="column">
                    <span class="has-text-weight-bold">You have pre-registered for this conference.</span><br>Additional information for this event may be made available to you as the event approaches.
                </div>
            </div>
            <div v-else>
                <b-message type="is-warning" class="mb-6" v-if="registration.is_po_pending">
                    <strong>Please Note: </strong>
                    You opted to use a Purchase Order (P.O.) for your registration. Your registration will not be complete until the purchase order process is complete.  Sessions and other content might not be available until the process is complete. Please contact the event organizer if you have any questions.
                    <div class="mt-5 mb-4">
                        <router-link :to="{name: 'po-request'}">
                        <b-button type="is-warning" style="color:white;"><i class="fad fa-file-invoice mr-3"></i>Manage Purchase Order (P.O.)</b-button>
                        </router-link>
                    </div>
                </b-message>
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../../http_client";
    import moment from "moment";
    import UiCard from "../../../components/UiCard";

    export default {
        components: {UiCard},
        props: ['registrationId'],
        data: function() {
            return {
                registration: {conference: {}}
            };
        },
        computed: {
            isPreRegistation: function() {
                return moment().isBefore(moment(this.registration.conference.start_at));
            },
        },
        methods: {
            loadRegistration: function(force) {
                http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                    this.registration = response.data;
                });
            }
        },
        mounted() {
            this.loadRegistration();
        }
    };
</script>

<style scoped>

</style>
